"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgDatapools: {
        id: 'datapools.datapools',
        defaultMessage: 'Datapools',
    },
    msgNewDatapoolPageModule: {
        id: 'newDatapool.pageModule.title',
        defaultMessage: 'Module Type & Datapool Name',
    },
    msgNewDatapoolStepInputFormatTitle: {
        id: 'newDatapool.stepInputFormat.title',
        defaultMessage: 'Select Input Format',
    },
    msgNewDatapoolStepInputFormatDescription: {
        id: 'newDatapool.stepInputFormat.description',
        defaultMessage: 'Select the Input format for your Datapool',
    },
    msgDatapoolMissingInputFormat: {
        id: 'newDatapool.stepInputFormat.error.missing_datapool_input_format',
        defaultMessage: 'Please select a Input Format for your Datapool',
    },
    msgNewDatapoolStepDataSourceTitle: {
        id: 'newDatapool.stepDataSource.title',
        defaultMessage: 'Select Data Source',
    },
    msgNewDatapoolStepDataSourceDescription: {
        id: 'newDatapool.stepDataSource.description',
        defaultMessage: 'Select the Data Source storage backend for your Datapool',
    },
    msgDatapoolMissingDataSourceCode: {
        id: 'newDatapool.stepDataSource.error.missing_datasource_code',
        defaultMessage: 'Please select a Data Source as storage backend for your Datapool',
    },
    newDatapoolStepDataSourceLabel: {
        id: 'newDatapool.stepDataSource.label',
        defaultMessage: 'Select Data Source',
    },
    newDatapoolStepDataSourcePlaceholder: {
        id: 'newDatapool.stepDataSource.placeholder',
        defaultMessage: 'No Data Source selected',
    },
    msgDatapoolSettingsDatapoolTitle: {
        id: 'dashboard.datapool_settings.datapool_title',
        defaultMessage: 'Datapool',
    },
    msgDatapoolSettingsDatapoolDescription: {
        id: 'dashboard.datapool_settings.datapool_description',
        defaultMessage: 'Name, Code and Input Format of the Datapool',
    },
    msgDatapoolSettingsHabitatTitle: {
        id: 'dashboard.datapool_settings.habitat_title',
        defaultMessage: 'Habitat',
    },
    msgDatapoolSettingsHabitatDescription: {
        id: 'dashboard.datapool_settings.habitat_description',
        defaultMessage: 'Name and Code of the Habitat this Datapool is based on',
    },
    msgDatapoolSettingsDataSourceTitle: {
        id: 'dashboard.datapool_settings.datasource_title',
        defaultMessage: 'Data Source',
    },
    msgDatapoolSettingsDataSourceDescription: {
        id: 'dashboard.datapool_settings.datasource_description',
        defaultMessage: 'Name and Code of the Data Source this Datapool uses as a storage backend',
    },
    // Datapool Details Overlay
    dashboardDatapoolSettingsActionBarModuleType: {
        id: 'dashboard.datapool_settings.action_bar.module_type',
        defaultMessage: 'Type:',
    },
    dashboardDatapoolSettingsActionBarDataSource: {
        id: 'dashboard.datapool_settings.action_bar.data_source',
        defaultMessage: 'Data Source:',
    },
    dashboardDatapoolSettingsActionBarInputFormat: {
        id: 'dashboard.datapool_settings.action_bar.input_format',
        defaultMessage: 'Input Format:',
    },
    // Datapool Details
    datapoolDetailsIndicatorNoDatasourceHeadline: {
        id: 'datapool_details.indicator.no_datasource.headline',
        defaultMessage: 'No Data Source',
    },
    datapoolDetailsIndicatorNoDatasourceDescription: {
        id: 'datapool_details.indicator.no_datasource.description',
        defaultMessage: 'No Data Source',
    },
});
//# sourceMappingURL=datapools.js.map